/**
 * Kpathport 관련 상수
 */

// Step Indicator 관련
export const BOOKING_STEPS = [1, 2, 3];
export const STEP_NAMES = {
  1: 'My Bag',
  2: 'Check details',
  3: 'Choose payment option',
};

// 아이콘 경로
export const getNextIconPath = () => {
  return `${process.env.REACT_APP_ASSETS_URL}/Kpathport/icon-next.svg`;
};

// Google Maps 관련
export const GOOGLE_MAPS_CONFIG = {
  DEFAULT_ZOOM: 16,
  MEETING_POINT_LABEL: 'Meeting point',
};

